/**
 * Build-time configuration, read once.
 *
 * There is deliberately no build-time auth switch any more. Sign-in used to be
 * decided by whether `VITE_AUTH0_DOMAIN` was set, which meant a bundle could be
 * built that was structurally incapable of signing in and only said so at
 * redirect time. Now `GET /api/me` answering without a session simply *is* dev
 * mode, discovered at runtime from the server that actually knows.
 */

function trimmed(value: string | undefined): string {
  return (value ?? '').trim();
}

/** Same-origin by default: the controller serves this bundle itself. */
export const apiBaseUrl = trimmed(import.meta.env.VITE_API_BASE_URL).replace(
  /\/+$/,
  '',
);
